var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightBackgroundLines2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 264,
    viewBox: "0 0 146 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.208 387V262.39C157.208 254.616 150.906 248.313 143.132 248.313H70.7983C63.5101 248.313 57.6019 242.405 57.6019 235.117V106.885C57.6019 99.1107 51.2997 92.8086 43.5257 92.8086L0.430664 92.8087",
    stroke: "url(#paint0_linear_1238_92483)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2822 160.891L93.834 160.891C101.122 160.891 107.03 166.799 107.03 174.087V285.733C107.03 293.021 112.939 298.93 120.227 298.93H307.114",
    stroke: "url(#paint1_linear_1238_92483)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.111 -14V73.4455H157.204V0.0761757C157.204 -7.69789 150.902 -14 143.128 -14H57.2666",
    stroke: "url(#paint2_linear_1238_92483)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0166 65.3262H111.027V139.471C111.027 146.759 116.935 152.667 124.224 152.667H211.048V239.593H310.861",
    stroke: "url(#paint3_linear_1238_92483)",
    strokeWidth: 0.528459
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1238_92483",
    x1: 170.897,
    y1: 362.989,
    x2: 20.9553,
    y2: 72.2708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1238_92483",
    x1: 330.675,
    y1: 287.663,
    x2: 306.863,
    y2: 118.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1238_92483",
    x1: 328.926,
    y1: 66.3086,
    x2: 318.499,
    y2: -42.0884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1238_92483",
    x1: 332.676,
    y1: 225.37,
    x2: 292.361,
    y2: 15.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBackgroundLines2);
export default __webpack_public_path__ + "static/media/right-backgroundLines2.50973a63ecb1347097d99ac1aef47729.svg";
export { ForwardRef as ReactComponent };